import { createFileRoute } from '@tanstack/react-router'

import { SearchField, SectionLabel } from '@/components/shared'
import { ThreadRow } from '@/components/spravce/chaty'
import { NEEDS_YOU, QUIET } from '@/mocks/spravce/chaty'

export const Route = createFileRoute('/spravce/chaty/')({
  head: () => ({ meta: [{ title: 'Chaty · Aplikace Bitez' }] }),
  component: SpravceChaty,
})

/**
 * Her inbox, split the way her production board already splits clients:
 * **what needs her, and what is running by itself.**
 *
 * Sorting by recency told her nothing — the newest message is often the one
 * that needs her least ("díky!"), while the thread that matters is the one
 * where somebody is waiting for an answer. The same two headings as Plány, on
 * purpose: one habit, two screens.
 *
 * Since 2026-08-18 the inbox carries **two kinds of thread** (open-items B12):
 * venues and her photographers, who talk to her and never to the client.
 * Nothing labels them — square avatars are places, round ones are people.
 */
function SpravceChaty() {
  return (
    <div className="px-4 pt-6 pb-6">
      {/* She has thirty conversations; a client has one. Search is a manager's
          tool, and it looks the same here as in her directory. */}
      <SearchField placeholder="Hledat v chatech" />

      <section className="animate-rise-up mt-7">
        <SectionLabel>Čeká na vás</SectionLabel>
        <div className="mt-4 space-y-4">
          {NEEDS_YOU.map((thread, index) => (
            <div
              key={thread.venue}
              className="animate-rise-up"
              style={{ animationDelay: `${index * 60}ms` }}
            >
              <ThreadRow thread={thread} />
            </div>
          ))}
        </div>
      </section>

      <section className="animate-rise-up mt-8" style={{ animationDelay: '120ms' }}>
        <SectionLabel>Běží samo</SectionLabel>
        <div className="mt-4 space-y-4">
          {QUIET.map((thread) => (
            <ThreadRow key={thread.venue} thread={thread} />
          ))}
        </div>
      </section>
    </div>
  )
}
